import React from 'react';
import SupportTicketConfigurationDetailSection from '../../../sections/AdminDashboard/Configuration/SupportTicketConfigurationDetail';

const SupportTicketConfigurationDetail = () => <SupportTicketConfigurationDetailSection />;

export default SupportTicketConfigurationDetail;
